import React from 'react';
import { Typography, Space } from 'antd';
import styled from 'styled-components';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';
import mexicoTopoJSON from '../../../assets/mexico.json';

const { Title, Text } = Typography;

const ChartCard = styled.div`
  background: white;
  border-radius: 20px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04);
  height: 100%;
`;

const MapLegend = styled.div`
  position: absolute;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  width: 180px;
`;

const LegendColor = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};
`;

const MexicoMapSVG = () => (
    <ComposableMap
        projection="geoMercator"
        projectionConfig={{
            scale: 1200,
            center: [-102, 24],
        }}
        width={1000}
        height={600}
        style={{ width: '100%', height: 'auto' }}
    >
        <Geographies geography={mexicoTopoJSON}>
            {({ geographies }) =>
                geographies.map((geo) => (
                    <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        style={{
                            default: {
                                fill: "#0d47a1",
                                stroke: "#ffffff",
                                strokeWidth: 0.5,
                                outline: "none",
                            },
                            hover: {
                                fill: "#1e90ff",
                                outline: "none",
                            },
                            pressed: {
                                fill: "#00c2ff",
                                outline: "none",
                            },
                        }}
                    />
                ))
            }
        </Geographies>

        {/* Markers with coordinates */}
    </ComposableMap>
);

const CoverageMap = ({ data }) => {
    const rawData = data?.specialistsByState || [];
    const totalCount = rawData.reduce((acc, item) => acc + (item.count || 0), 0);

    const coverageData = [...rawData]
        .sort((a, b) => (b.count || 0) - (a.count || 0))
        .slice(0, 4)
        .map(item => {
            const percentage = totalCount > 0
                ? ((item.count / totalCount) * 100).toFixed(2)
                : 0;
            return {
                name: item.state,
                percentage: `${percentage}%`,
                color: '#00D1FF'
            };
        });

    return (
        <ChartCard style={{ position: 'relative' }}>
            <Title level={5} style={{ marginBottom: 20, color: '#334155' }}>Cobertura por Estado</Title>
            <div style={{ textAlign: 'center' }}>
                <MexicoMapSVG />
            </div>
            <MapLegend>
                {coverageData.length > 0 ? coverageData.map((item) => (
                    <LegendItem key={item.name}>
                        <Space>
                            <LegendColor color={item.color} />
                            <Text style={{ fontSize: 13, fontWeight: 600 }}>{item.name}</Text>
                        </Space>
                        <Text style={{ color: '#00c2ff', fontWeight: 800 }}>{item.percentage}</Text>
                    </LegendItem>
                )) : (
                    <Text type="secondary">Cargando cobertura...</Text>
                )}
            </MapLegend>
        </ChartCard>
    );
};

export default CoverageMap;
